import React from 'react';
import EditIcon from '@material-ui/icons/Edit';
import LinkIcon from '@material-ui/icons/Link';
import PersonIcon from '@material-ui/icons/Person';
import EmailIcon from '@material-ui/icons/Email';
import Tooltip from "@material-ui/core/Tooltip";

const WarningReasonIcon = ({reason}) => {
    const renderReasonIcon = (reason) => {
        if (reason === "name" || reason==="foundation_contact_name") {
            return <Tooltip title={"Same Name"}>
                <EditIcon style={{color: "#ff9900"}} fontSize="small" />
            </Tooltip>
        } else if (reason === "url" || reason === "web_url") {
            return <Tooltip title={"Same URL"}>
                <LinkIcon style={{color: "#ff9900"}} fontSize="small" />
            </Tooltip>
        } else if (reason === "url_redirect") {
            return <Tooltip title={"URL redirects to the same destination"}>
                <LinkIcon style={{color: "#ff9900"}} fontSize="small" />
            </Tooltip>
        } else if (reason === "members") {
            return <Tooltip title={"Same Contacts"}>
                <PersonIcon style={{color: "#ff9900"}} fontSize="small" />
            </Tooltip>
        } else if (reason === "company_email") {
            return <Tooltip title={"Same Company Email"}>
                <EmailIcon style={{color: "#ff9900"}} fontSize="small" />
            </Tooltip>
        } else if (reason === "company_linkedin") {
            return <Tooltip title={"Same Company Linkedin profile"}>
                <LinkIcon style={{color: "#ff9900"}} fontSize="small" />
            </Tooltip>
        } else if (reason === "ria_contact_name") {
            return <Tooltip title={"RIA Contact has same name"}>
                <EditIcon style={{color: "#ff9900"}} fontSize="small" />
            </Tooltip>
        } else {
            return null
        }
    }

    return renderReasonIcon(reason);
}

export default WarningReasonIcon;
